import type {HostMap} from '../../../types'

export const TESTING = {
  account: 'delivery-frontend-account-yandexcom.delivery.tst.yandex.net',
  auth: 'delivery-frontend-auth-yandexcom.delivery.tst.yandex.net',
  route: 'ddelivery-frontend-route-yandexcom.delivery.tst.yandex.net',
  tariffs: 'delivery-frontend-tariffs-lb-yandexcom.delivery.tst.yandex.net',
  yaAuthProxy: {
    default: 'ya-authproxy.taxi.tst.yandex.com',
    authorized: 'ya-authproxy.taxi.tst.yandex.com',
  },
  avatars: 'avatars.mdst.yandexcom.net',
  passport: {
    default: 'passport-test.yandex.com',
    id: 'id-test.yandex.com',
    api: 'api.passport-test.yandex.com',
  },
} as const satisfies HostMap
